import Layout from '@/layout'

const route = {
  path: '/approver',
  component: Layout,
  redirect: '/approver/index',
  alwaysShow: true, // will always show the root menu
  name: 'approver',
  meta: {
    title: 'approver',
    icon: 'el-icon-document-checked',
    roles: [
      'larke-admin.approver.index'
    ]
  },
  sort: 110070,
  children: [
    // 扩展管理
    {
      path: '/approver/index',
      component: () => import('@/views/approver/index'),
      name: 'approverIndex',
      meta: {
        title: 'approverIndex',
        icon: 'el-icon-tickets',
        roles: [
          'larke-admin.approver.index'
        ]
      }
    }
  ]
}

export default route
